<template>
  <div class="px-5">
    <h3 class="grey--text pt-10 pb-5">
      {{ $t('transfer.details.history.label') }}
    </h3>

    <v-card outlined>
      <v-data-table
        disable-sort
        mobile-breakpoint="20"
        :items-per-page="10"
        :headers="historyHeaders"
        :items="transfer.transfer_history"
        :footer-props="{
          'items-per-page-text': '',
          'items-per-page-options': [],
        }"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
      >
        <template v-slot:[`item.created_at`]="{ item }">
          <span class="body-2" v-if="item.created_at">
            {{ formatDate(item.created_at) }}
          </span>
          <span class="body-2" v-else>---</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <span class="body-2" v-if="item.status">
            {{ $t(`transfer.transferStatus.${item.status}`) }}
          </span>
          <span class="body-2" v-else>---</span>
        </template>
        <template v-slot:[`item.description`]="{ item }">
          <span class="body-2" v-if="item.description">
            {{ item.description }}
          </span>
          <span class="body-2" v-else>---</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { transferHistoryHeaders } from '@/views/listHeaders/transferHeaders'

export default {
  name: 'TransferHistory',

  props: {
    transfer: {
      type: Object,
    }
  },

  data() {
    return {
      formatDate: catalogDate,
      formatMoney: catalogMonetary,
      historyHeaders: transferHistoryHeaders,
    }
  }
}
</script>
